import styled from 'styled-components';
import {basicColor, font, radius} from '../../../../../styles/template';
import TextareaAutosize from 'react-textarea-autosize';

export const Label = styled.label`
	${font.basicBoldS};
	color: ${({ theme }) => theme.color.Text};
`;


export const StyledTextarea = styled(TextareaAutosize)`
	width: 100%;
	min-height: 12rem;
	background: ${({ theme }) => theme.color.Item};
	${font.basic};
	color: ${({ theme }) => theme.color.Text};
	border-radius: ${radius.normal};
	padding: 2rem;
	

	&.isError {
		border: 1px solid ${basicColor.red};
	}
	
	&:disabled {
		background: ${({ theme }) => theme.color.MidtoneItem};
		cursor: not-allowed;
		pointer-events: all !important;
	}
`;

